"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bcmTargetSearchReducer = exports.bcmTargetSearchActions = exports.TYPES = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'bcmTargetSearch';

// アクションタイプ
const TYPES = exports.TYPES = {
  CHANGE_CONDITION: PREFIX + 'ChangeCondtion',
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  GO_MAIN: PREFIX + 'GoMain',
  GO_DELETE: PREFIX + 'GoDelete',
  GO_UPDATE: PREFIX + 'GoUpdate',
  SET_CONTENT: PREFIX + 'SetContent',
  RESET_PAGING: PREFIX + 'ResetPaging',
  CHANGE_PAGE: PREFIX + 'ChangePage',
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  CLEAR: PREFIX + 'Clear'
};

// 表示コンテンツ
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  DELETE: 'delete',
  DELETE_RESULT: 'deleteResult',
  UPDATE: 'update'
};

// 初期状態
const INIT_STATE = {
  containerInfo: {
    dispContent: CONTENTS.MAIN
  },
  searchConditions: {
    kaishaCd: '',
    soshikiCd: '',
    bcmKaishaSoshikiCd: '',
    kaishaSoshikiLabel: ''
  },
  jigyoInfo: {},
  searchResult: [],
  showAll: false,
  paging: {
    [CONTENTS.MAIN]: {
      viewNum: 50,
      currentPage: 0
    }
  },
  scrollTop: {
    [CONTENTS.MAIN]: {
      index: 0,
      scrollY: 0,
      noSticky: false
    }
  },
  doSearch: false
};
const bcmTargetSearchActions = exports.bcmTargetSearchActions = (0, _reduxActions.createActions)({
  [TYPES.CHANGE_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_MAIN]: function () {
    return {
      doSearch: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_DELETE]: function () {
    return {
      jigyoInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_UPDATE]: function () {
    return {
      jigyoInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      currentPage: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      viewNum: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.RESET_PAGING]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      scrollTop: arguments.length <= 1 ? undefined : arguments[1]
    };
  }
}, TYPES.CLEAR);
const bcmTargetSearchReducer = exports.bcmTargetSearchReducer = (0, _reduxActions.handleActions)({
  [TYPES.CHANGE_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    doSearch: false
  }),
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: newSearchResult,
      showAll: action.payload.showAll
    });
  },
  [TYPES.GO_DELETE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    jigyoInfo: action.payload.jigyoInfo,
    containerInfo: {
      dispContent: CONTENTS.DELETE
    }
  }),
  [TYPES.GO_UPDATE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    jigyoInfo: action.payload.jigyoInfo,
    containerInfo: {
      dispContent: CONTENTS.UPDATE
    }
  }),
  [TYPES.SET_CONTENT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    containerInfo: {
      dispContent: action.payload.content
    }
  }),
  [TYPES.GO_MAIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContent: CONTENTS.MAIN
    }),
    doSearch: action.payload.doSearch
  }),
  [TYPES.RESET_PAGING]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      [action.payload.key]: _objectSpread({}, INIT_STATE.paging[action.payload.key])
    })
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state.paging[action.payload.key]), {}, {
        currentPage: action.payload.currentPage
      })
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      [action.payload.key]: {
        currentPage: 0,
        viewNum: action.payload.viewNum
      }
    })
  }),
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: _objectSpread(_objectSpread({}, state.scrollTop), {}, {
      [action.payload.key]: action.payload.scrollTop
    })
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);